/**
 * Device identity persistence (SCN-612).
 *
 * `screenId` survives an unpair so the device re-pairs against the same DisplayScreen row; only a
 * 404 from /status clears it. `authToken` is cleared on a 401 (revoked) without touching screenId.
 * Every access is guarded — a kiosk browser with storage disabled must still boot.
 */
const SCREEN_ID_KEY = 'scanify_display_screen_id';
const AUTH_TOKEN_KEY = 'scanify_display_auth_token';

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage unavailable — run from memory this session */
  }
}

function remove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export const storage = {
  getScreenId: () => read(SCREEN_ID_KEY),
  setScreenId: (id: string) => write(SCREEN_ID_KEY, id),
  clearScreenId: () => remove(SCREEN_ID_KEY),

  getAuthToken: () => read(AUTH_TOKEN_KEY),
  setAuthToken: (token: string) => write(AUTH_TOKEN_KEY, token),
  clearAuthToken: () => remove(AUTH_TOKEN_KEY),
};
